import React from 'react';
import New_Employe from './New_Employe';
import '../../../CommonCSS/SocietyCSS.css'


const New_EmployeApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> Add Employe </h5>
          </div>
        </div>
        <New_Employe/>
      </div>
    </div >
  );
};

export default New_EmployeApp;
